<template>
  <AsyncComponent :component-path="viewPath"></AsyncComponent>
</template>

<script>
import AsyncComponent from '../../../elements/async/AsyncComponent'
export default {
  name: 'CustomPanel',
  components: {
    AsyncComponent
  },
  props: {
    viewPath: {
      type: String,
      required: true
    }
  }
}
</script>
